import { ProviderWebsiteModel } from '../../../shared/models/provider-website-model';
import { SubscriberOccupationCategoryModel } from './subscriber-occupation-category-model';
import { Serializable } from '../../../core/models/serializable';
import { SubscriberLocalitySubscriptionModel } from './subscriber-locality-subscription-model';
export class SubscriberModel implements Serializable<SubscriberModel> {
  fromObject(obj: any): SubscriberModel {
    Object.assign(this, obj);
    this.subscribedCategories = [];
    this.subscribedLocalities = [];
    this.originWebsite = null;

    if (
      obj.subscribedCategories &&
      obj.subscribedCategories.length &&
      obj.subscribedCategories.length > 0
    ) {
      obj.subscribedCategories.forEach((w) => {
        let t = new SubscriberOccupationCategoryModel();
        t = t.fromObject(w);
        this.subscribedCategories.push(t);
      });
    }

    if (
      obj.subscribedLocalities &&
      obj.subscribedLocalities.length &&
      obj.subscribedLocalities.length > 0
    ) {
      obj.subscribedLocalities.forEach((sl) => {
        let t = new SubscriberLocalitySubscriptionModel();
        t = t.fromObject(sl);
        this.subscribedLocalities.push(t);
      });
    }

    if (obj.originWebsite != null) {
      let t = new ProviderWebsiteModel();
      t = t.fromObject(obj.originWebsite);
      this.originWebsite = t;
    }

    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public subscriberId: number;
  public name: string;
  public email: string;
  public subscriberStatusId: number;
  public dailyDigestOn: boolean;
  public createDate: Date;
  public subscribedCategories: SubscriberOccupationCategoryModel[];
  public subscribedLocalities: SubscriberLocalitySubscriptionModel[];
  public originWebsite: ProviderWebsiteModel;

  constructor() {
    this.subscribedCategories = [];
    this.subscribedLocalities = [];
  }
}
